import styled, { css } from 'styled-components';
import { Checkbox, CheckboxProps, CheckboxGroupItemProps, CheckboxGroupItem } from 'react-uforms';
import { IconStyled } from '@ch/common/components/icon';
import { colors } from '@ch/common/const/color';
import { marginStyle } from '@ch/common/const/helpers';
import { SizeProps } from '../../../const/size';
import { font } from '../../../const/font';
import { FormCheckboxToggleStyled } from './toggle';

export const FormCheckboxStyled = styled.label<{ $m?: number[] }>`
  position: relative;
  display: block;
  margin: ${({ $m }) => ($m ? `${$m.map(m => marginStyle(m)).join(' ')} !important` : '0')};
`;

export const FormCheckboxLabel = styled.span<{ $size?: SizeProps }>`
  display: flex;
  align-items: center;
  justify-content: start;
  cursor: pointer;
  font-size: ${({ $size }) => ($size ? `${font.size[$size]}px` : `${font.size.md}px`)};
  color: ${colors?.primary};
`;
export const FormCheckboxIcon = styled.span`
  min-width: 18px;
  width: 18px;
  height: 18px;
  border: 2px solid ${colors.primary};
  background: ${colors.white};
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-right: 8px;
  ${IconStyled} {
    display: none;
    * {
      fill: ${colors.white};
    }
  }
`;

const checkboxInputStyles = css`
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  &:checked ~ ${FormCheckboxLabel} {
    ${FormCheckboxIcon} {
      background-color: ${colors.primary};
      border-color: ${colors.primary};
      ${IconStyled} {
        display: block;
      }
    }

    ${FormCheckboxToggleStyled} {
      background-color: ${colors.primary};
      &:after {
        left: auto;
        background-color: ${colors.white};
        right: 2px;
      }
    }
  }
  &:disabled {
    & ~ ${FormCheckboxLabel} {
      cursor: not-allowed;
      ${FormCheckboxIcon} {
        cursor: not-allowed;
        background-color: ${colors.grayMedium};
      }
    }
    &:checked {
      & ~ ${FormCheckboxLabel} {
        ${FormCheckboxIcon} {
          border-color: ${colors.grayMedium};
        }
      }
    }
  }
`;

export const FormCheckboxInput = styled(Checkbox)<CheckboxProps>`
  ${checkboxInputStyles}
`;

export const FormCheckboxGroupItemInput = styled(CheckboxGroupItem)<CheckboxGroupItemProps>`
  ${checkboxInputStyles}
`;
